import { StateCreator } from "zustand";
import { MeetingType, fromApiMeetingType } from "../model/meeting_type";
import { MeetingTypesResource } from "../api/meeting_types";

export interface MeetingTypesSlice {
  meetingTypes: MeetingType[];
  loadMeetingTypes: () => Promise<void>;
  getTypeById: (id: string) => MeetingType | undefined;
}

export const createMeetingTypesSlice: StateCreator<
  MeetingTypesSlice,
  [],
  [],
  MeetingTypesSlice
> = (set, get) => ({
  meetingTypes: [],
  loadMeetingTypes: async () => {
    const apiMeetingTypes = await MeetingTypesResource.getList();
    const raw = apiMeetingTypes.map(fromApiMeetingType);
    const seen = new Set<string>();
    const meetingTypes = raw.filter((t) => {
      if (seen.has(t.id)) return false;
      seen.add(t.id);
      return true;
    });
    meetingTypes.sort((a, b) => a.title?.localeCompare(b.title || "") || 0);
    set((_) => ({ meetingTypes }));
  },
  getTypeById: (id: string) => {
    const meetingTypes = get().meetingTypes;
    return meetingTypes.find((type) => type.id === id);
  },
});
